module.exports = __webpack_public_path__ + "img/wode_on.c45dd67a.png";